import { store } from '@betacrew/jars-flux';
import { all, call, put, takeLatest, takeLeading } from 'redux-saga/effects';
import ReconciliationDataService from '../../../../services/ReconciliationDataService';
import { TOASTER_VARIANT } from '../../../components/toast/constants';
import { PAGE_STATE } from '../../constants/constants';
import { addNotifications } from '../../toaster/ToasterPortalSlice';
import { componentKey, setFormDataFromRecordId, setIsReconciliationEditModeOn, setLoadingState, setSuccessfullySubmittedReconciliation, setTempFormFieldsList, updateFormsPreLoadedData, updateUserInteractionPopupWResponseObj } from './ReconciliationFormSubmitPopupSlice';
import { RECONCILIATION_SUBMIT_POPUP_LOADING_STATES } from './constants';

export const { getReconciliationFields, getReconciliationFormsPreloadedData, onDependentFieldChangeGetValues, saveReconciliation } = {
    getReconciliationFields: (payload) => {
        return {
            type: "SUBMIT_RECONCILIATION_POPUP/GET_FIELDS",
            payload: payload
        }
    },
    getReconciliationFormsPreloadedData: (payload) => {
        return {
            type: "SUBMIT_RECONCILIATION_POPUP/GET_PRELOADED_DATA",
            payload: payload
        }
    },
    onDependentFieldChangeGetValues: (payload) => {
        return {
            type: "SUBMIT_RECONCILIATION_POPUP/ONDEPENDENT_FIELD_CHANGE_VALUES",
            payload: payload
        }
    },
    saveReconciliation: (payload) => {
        return {
            type: "SUBMIT_RECONCILIATION_POPUP/SAVE",
            payload: payload
        }
    },
}

function* getReconciliationFieldsAsync(action){
    try {

        const {formName, taxYear, toCreateFormData, formsPreLoadedData, returnedFormRecordIdData, isFormEditMode, quarter} = action.payload;
        yield put(setLoadingState({ state: RECONCILIATION_SUBMIT_POPUP_LOADING_STATES.CONFIGURATIONS_LOADING }));
        
        const response = yield ReconciliationDataService.getFormFields(formName, quarter);
        yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }));
        if(response?.data?.Status){
            const updatedFieldsList = response?.data?.Data.map((item) => {
                
                const prepopulateField = formsPreLoadedData.hasOwnProperty(item?.FrontEndSource) ? formsPreLoadedData[item?.FrontEndSource] : null;
                if(isFormEditMode && returnedFormRecordIdData.hasOwnProperty(item?.Name)){
                    return {
                        ...item,
                        inputValue: returnedFormRecordIdData[item?.Name],
                    }
                } else if(item.Name === "FormName"){
                    return {
                        ...item,
                        inputValue: toCreateFormData?.selectedForm?.FormId ?? null,
                    }
                }
                else if (!Array.isArray(prepopulateField) && typeof prepopulateField !== "object" && prepopulateField !== null) {
                    return {
                      ...item,
                      inputValue: prepopulateField,
                    };
                }
                return item;
            });
            yield put(setTempFormFieldsList(updatedFieldsList));
        }else{
            yield put(addNotifications({
                heading: "Failed to get the fields",
                message: response.data.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    }catch(error) {
        console.log(error)
        yield put(addNotifications({
            heading: "Error",
            message: "We are facing some error. Please try again",
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: RECONCILIATION_SUBMIT_POPUP_LOADING_STATES.CONFIGURATIONS_READY }));
    }
}

function* getReconciliationFormsPreloadedDataAsync(action){
    try {
        const {formsPreLoadedData, getFormFieldsFlag, toCreateFormData, formName, payerId, taxYear, isFormEditMode, formRecordId, referenceid, quarter, state, setScheduleReconciliationDateCb} = action.payload;
        yield put(setLoadingState({ state: RECONCILIATION_SUBMIT_POPUP_LOADING_STATES.CONFIGURATIONS_LOADING }));
        
        let recordIdResponse;
        let formPreLoadedDataResponse;

        if(isFormEditMode){
            recordIdResponse = yield call(ReconciliationDataService.getFormByRecordId, formName, formRecordId);
            formPreLoadedDataResponse = yield call(ReconciliationDataService.getReconciliationPreloadedData, formName, payerId, taxYear, referenceid, state, quarter);
        }else{
            formPreLoadedDataResponse = yield ReconciliationDataService.getReconciliationPreloadedData(formName, payerId, taxYear, referenceid, state, quarter);
        }

        let returnedFormRecordIdData = null;
        let stopHere = false;

        if(isFormEditMode){
            if(recordIdResponse?.data?.Status === 1){
                returnedFormRecordIdData = recordIdResponse?.data?.Data;
                yield put(setFormDataFromRecordId(returnedFormRecordIdData));
            }else{
                yield put(addNotifications({
                    heading: "Error",
                    message: recordIdResponse?.data?.Message,
                    variant: TOASTER_VARIANT.DANGER
                }));
                yield put(setIsReconciliationEditModeOn(false));
                stopHere = true;
            }
        }
        if(!stopHere){
            if(formPreLoadedDataResponse?.data?.Status === 0){
                yield put(addNotifications({
                    heading: "Error",
                    message: formPreLoadedDataResponse?.data?.Message,
                    variant: TOASTER_VARIANT.DANGER
                }));
            }else{
                let tempFormsPreLoadedData = {};
                const returnedFormData = formPreLoadedDataResponse?.data?.Data ?? {};
                for (const key in returnedFormData) {
                    if(returnedFormData[key]){
                        tempFormsPreLoadedData[key] = returnedFormData[key];
                    }
                }
                yield put(updateFormsPreLoadedData({...tempFormsPreLoadedData}));
    
                if(getFormFieldsFlag){
                    yield call(getReconciliationFieldsAsync, { payload: { formName: formName, taxYear: taxYear, toCreateFormData: toCreateFormData, formsPreLoadedData: {
                        ...formsPreLoadedData,
                        ...tempFormsPreLoadedData,
                    },
                    returnedFormRecordIdData: returnedFormRecordIdData,
                    isFormEditMode: isFormEditMode,
                    quarter: quarter,
                 } });
                }
            }
        }
    }catch(error){
        console.log(error)
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    }finally {
        yield put(setLoadingState({ state: RECONCILIATION_SUBMIT_POPUP_LOADING_STATES.CONFIGURATIONS_READY }))
    }
}

function* onDependentFieldChangeGetValuesAsync(action){
    try {
        yield put(setLoadingState({ state: RECONCILIATION_SUBMIT_POPUP_LOADING_STATES.DEPENDENT_FIELD_CHANGE_LOADING }));
        const response = yield ReconciliationDataService.calculateInferredValues(action.payload);
        yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }));
        if(response.data.Status === 0){
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }else{
            if(response?.data?.Data?.interaction){
                yield put(updateUserInteractionPopupWResponseObj({
                    ...response.data.Data.interaction
                }));
            }
        }
        const responseDataArray = response?.data?.Data?.allFields ?? [];
        yield put(setTempFormFieldsList(responseDataArray));
    } catch(error) {
        console.log(error)
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    }finally {
        yield put(setLoadingState({ state: RECONCILIATION_SUBMIT_POPUP_LOADING_STATES.DEPENDENT_FIELD_CHANGE_READY }))
    }
}

function* saveReconciliationAsync(action){
    try {
        const {formData} = action.payload;
        yield put(setLoadingState({ state: RECONCILIATION_SUBMIT_POPUP_LOADING_STATES.SAVE_FORM_LOADING }));
        const response = yield ReconciliationDataService.saveReconciliation(formData);
        yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }));
        if(response.data.Status === 0){
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }else{
            yield put(addNotifications({
                heading: "Success",
                message: "Successfully saved reconciliation",
                variant: TOASTER_VARIANT.SUCCESS
            }));
            yield put(setSuccessfullySubmittedReconciliation(true));
        }
    } catch(error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    }finally {
        yield put(setLoadingState({ state: RECONCILIATION_SUBMIT_POPUP_LOADING_STATES.SAVE_FORM_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getReconciliationFields().type, getReconciliationFieldsAsync),
        takeLatest(getReconciliationFormsPreloadedData().type, getReconciliationFormsPreloadedDataAsync),
        takeLatest(onDependentFieldChangeGetValues().type, onDependentFieldChangeGetValuesAsync),
        takeLatest(saveReconciliation().type, saveReconciliationAsync),
    ]);
}
store.sagaManager.addSaga(componentKey, rootSaga);